import React, { Component } from "react"
import { Col } from "react-bootstrap"

import "../styles/questionImages.css"
import "../../../../../src/styles/styles.css"

class CoinFlip extends Component {
  constructor(props) {
    super(props)

    this.state = {
      coinSide: this.props.players[0],
    }

    this.flipCoin = this.flipCoin.bind(this)
  }

  componentDidMount() {
    if (this.intervalCoin) {
      clearInterval(this.intervalCoin)
    }

    this.intervalCoin = setInterval(this.flipCoin, 75)
  }

  componentWillUnmount() {
    clearInterval(this.intervalCoin)
  }

  flipCoin() {
    const { players } = this.props

    this.setState({
      coinSide:
        this.state.coinSide.user_id === players[0].user_id
          ? players[1]
          : players[0],
    })
  }

  render() {
    return (
      <Col xs={12} sm={12} className="winnerContainer p40">
        <h3 className="fontFamilyBold fontColorGray winnerLabel">
          AND THE WINNER IS...
        </h3>

        <h3 className="fontFamilyBold fontColorBlack winnerLabel">
          {this.state.coinSide.username}
        </h3>
      </Col>
    )
  }
}

export default CoinFlip



// WEBPACK FOOTER //
// ./src/components/questionsWindow/questionImages/coinFlip/view.js